// API configuration. In prod the frontend is served by Caddy on the SAME
// origin as the API, so the build sets REACT_APP_API_URL='' (relative paths);
// ?? keeps that empty string instead of falling back to localhost.
export const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:4000';

// Wrapper that always includes credentials so session cookies are sent
export const apiFetch = (path, options = {}) =>
  fetch(`${API_URL}${path}`, { credentials: 'include', ...options });
